// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile =  {
    "aws_project_region": "ap-northeast-1",
    "aws_cognito_region": "ap-northeast-1",
    "aws_user_pools_id": "ap-northeast-1_tFvdkF2xz",
    "aws_user_pools_web_client_id": "5h0nkas2puurnbs22cjn7fmee3",
    "aws_dynamodb_all_tables_region": "ap-northeast-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "timeaxis",
            "region": "ap-northeast-1"
        }
    ],
    "aws_cloud_logic_custom": [
        {
            "name": "timeaxis",
            "endpoint": "https://df5eneamih.execute-api.ap-northeast-1.amazonaws.com/Prod",
            "region": "ap-northeast-1"
        }
    ],
    "aws_content_delivery_bucket": "timeaxis-20190115090126--hostingbucket",
    "aws_content_delivery_bucket_region": "ap-northeast-1",
    "aws_content_delivery_url": "http://timeaxis-20190115090126--hostingbucket.s3-website-ap-northeast-1.amazonaws.com"
};


export default awsmobile;
